import { render, staticRenderFns } from "./SingleFile.vue?vue&type=template&id=142fc7a9&scoped=true&"
import script from "./SingleFile.vue?vue&type=script&lang=js&"
export * from "./SingleFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142fc7a9",
  null
  
)

export default component.exports